import styled from 'styled-components';
export const EcomSearcContainer = styled.div`
	& > .ff-hero-container {
		overflow: auto;
		height: calc(100vh - 71px);
		& > img {
			width: 100%;
		}
		& > div {
			padding: 24px 0 54px 24px;
			& .custom-carousel {
				& ul {
					gap: 24px;
				}
			}
		}
	}
	.ff-no-products {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
		& > div {
			text-align: center;
			max-width: 294px;
			& > img {
				margin-bottom: 20px;
			}
			& > .sorry {
				font-size: 20px;
				font-style: normal;
				font-weight: 200;
				line-height: 28px; /* 140% */
				letter-spacing: 0.6px;
				color: var(--neutral-color-ff-neutral800);
			}
			& > .search-term {
				font-size: 14px;
				font-style: normal;
				font-weight: 200;
				line-height: 21px; /* 150% */
				letter-spacing: 0.42px;
				color: var(--neutral-color-ff-neutral800);
			}
		}
	}
`;
export const SortFilterContainer = styled.div`
	z-index: 2;
	display: flex;
	align-items: center;
	position: fixed;
	bottom: 0;
	width: 100vw;
	padding: 10px 0;

	& > .ff-sort,
	& > .ff-filter {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 50%;
		gap: 4px;
	}
	& > .ff-sort {
		border-right: 1px solid #cfbced;
	}

	border-top: 1px solid #cfbced;
	background: #fff;
	.ff-filter-modal {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		background: #fff;
		height: 80vh;
		overflow-y: auto;

		& > .title,
		& > .footer {
			display: flex;
			justify-content: space-between;
			padding: 15px 10px;
			background: white;
			& > div:last-child {
				color: var(--secondary-color-ff-secondary500);
			}
			&.footer {
				border-top: 1px solid #eaeaec;
				position: fixed;
				bottom: 0;
				width: 100%;
				left: 0;
				& > div:first-child {
					color: #3e4152;
					border-right: 1px solid #eaeaec;
				}
				& > div {
					width: 50%;
					display: flex;
					justify-content: center;
				}
			}

			&.title {
				border-bottom: 1px solid #eaeaec;
				& > div:first-child {
					color: #424553;
					font-weight: bold;
				}
			}
		}
		& > .ff-filter-content {
			display: grid;
			grid-template-columns: 33.33% auto;
			height: 100%;
			& > .filters {
				background: #f5f5f6;
				height: auto;
			}
			& > div > div:not(:last-child) {
				border-bottom: 1px solid #eaeaec;
			}
			& > div {
				overflow: auto;
				height: calc(100vh - 30vh - 58px);
				text-transform: capitalize;
			}
			& > div > .data {
				& > div:first-child {
					background: #f5f5f6;
				}
				&.active > div:first-child {
					background: #fff;
				}
			}
		}
	}
	.ff-sort-modal-container {
		position: fixed;
		bottom: 0;
		left: 0;
		height: 100vh;
		background: var(--black-40);
		width: 100%;
	}
	.ff-sort-modal {
		background: white;
		width: 100%;
		border-radius: 12px 12px 0px 0px;
		background: #fff;
		box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.28);
		display: flex;
		flex-direction: column;
		position: fixed;
		bottom: 0;
		gap: 4px;
		padding-bottom: 10px;
		& > div:first-child {
			font-weight: 600;
			padding: 8px 12px;
			margin-top: 2px;
			color: #1c0047;
		}
		& > .data {
			padding: 8px 12px;
			color: #1c0047;
			display: flex;
			justify-content: space-between;
		}
		& > .data.active {
			background-color: #f6f2fb;
		}
	}
`;
